export default "__VITE_ASSET__a6674c5f__"